import dynamic from "next/dynamic";

export const DynamicContent035 = dynamic(() => import("./Content035"), {
  suspense: true,
});
